import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1703.53412,960 C1703.53412,918.211765 1699.69412,875.52 1691.90118,832.828235 L1902.08471,650.654118 L1702.63059,309.797647 L1437.44471,398.230588 C1370.47059,342.663529 1294.12235,298.842353 1213.59529,269.816471 L1158.93176,0 L761.152941,0 L706.489412,269.703529 C625.058824,298.842353 550.065882,341.985882 482.527059,398.117647 L217.454118,309.797647 L18,650.654118 L228.183529,832.828235 C220.390588,875.52 216.550588,918.211765 216.550588,960 C216.550588,1001.78824 220.390588,1044.48 228.183529,1087.17176 L18,1269.34588 L217.454118,1610.20235 L482.64,1521.76941 C549.614118,1577.33647 625.962353,1621.15765 706.489412,1650.18353 L761.152941,1920 L1158.93176,1920 L1213.59529,1650.29647 C1294.91294,1621.15765 1370.01882,1578.01412 1437.55765,1521.88235 L1702.63059,1610.31529 L1902.08471,1269.45882 L1691.90118,1087.28471 C1699.69412,1044.48 1703.53412,1001.78824 1703.53412,960 M960.042353,1355.29412 C742.065882,1355.29412 564.748235,1177.97647 564.748235,960 C564.748235,742.023529 742.065882,564.705882 960.042353,564.705882 C1178.01882,564.705882 1355.33647,742.023529 1355.33647,960 C1355.33647,1177.97647 1178.01882,1355.29412 960.042353,1355.29412",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconSettings2Solid = /*#__PURE__*/function (_Component) {
  _inherits(IconSettings2Solid, _Component);

  var _super = _createSuper(IconSettings2Solid);

  function IconSettings2Solid() {
    _classCallCheck(this, IconSettings2Solid);

    return _super.apply(this, arguments);
  }

  _createClass(IconSettings2Solid, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {}

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconSettings2",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconSettings2Solid.displayName = "IconSettings2Solid";
  return IconSettings2Solid;
}(Component);

IconSettings2Solid.glyphName = 'settings-2';
IconSettings2Solid.variant = 'Solid';
IconSettings2Solid.deprecated = true;
IconSettings2Solid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconSettings2Solid;
export { IconSettings2Solid };